import { initSentry } from "./lib/sentry";
import { SentryErrorBoundary } from "./lib/sentry";
import { initPostHog } from "./lib/posthog";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import "./index.css";

initSentry();
initPostHog();

function FallbackUI() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center text-foreground">
      <div className="text-center space-y-4">
        <h1 className="text-2xl font-bold">Something went wrong</h1>
        <p className="text-muted-foreground">An unexpected error occurred. Please refresh the page.</p>
        <button
          onClick={() => window.location.reload()}
          className="px-4 py-2 bg-primary text-primary-foreground rounded-md"
        >
          Refresh Page
        </button>
      </div>
    </div>
  );
}

createRoot(document.getElementById("root")!).render(
  <SentryErrorBoundary fallback={<FallbackUI />}>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </SentryErrorBoundary>
);
